interface MetricBoxProps {
  label: string;
  value: string | number;
}

export function MetricBox({ label, value }: MetricBoxProps) {
  return (
    <div className="bg-gray-50 p-2 rounded">
      <div className="text-xs text-gray-600">{label}</div>
      <div className="font-semibold">{value}</div>
    </div>
  );
}
